<!-- 组件 搜索栏点更多筛选和收起更多 -->
<template>
  <div class="CollapseTop">
    <div class="z-fixed">
      <div class="left"><slot name="search"></slot></div>
      <div class="moreBtn" @click="moreClick">
        <div class="right-btn z-fixed-c">
          <span>{{ !showBtm ? '更多筛选' : '收起更多' }}</span>
        </div>
      </div>
    </div>
    <div v-show="showBtm">
      <slot name="showSearch"></slot>
    </div>
  </div>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue'
defineProps({
  showBtm: {
    type: Boolean,
    value: false
  }
})
// const data = reactive({
//   showFun: false
// })
const emit = defineEmits(['moreClick'])
const moreClick = () => {
  emit('moreClick')
}
</script>
<style scoped>
.right-btn {
  width: 96px;
  height: 36px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
}
.left {
  max-width: 90%;
}
.CollapseTop {
  /* position: absolute; */
  background: #ffffff;
  padding: 8px 20px 0 20px;
  width: 100%;
  top: 0;
  z-index: 999;
}
.moreBtn {
  position: absolute;
  right: 20px;
  top: 8px;
}
</style>
